import { NAV_LINKS } from '../../data/content';
import { scrollToId } from '../../hooks/useLenis';
import logo from '../../assets/logo.png';

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 bg-navy-950 py-16"
  >
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-12 lg:flex-row">
        <div className="max-w-sm">
          <img
            src={logo}
            alt="London Biotech International Ltd"
            className="h-14 w-auto"
          />
          <p className="mt-6 text-sm leading-relaxed text-slate-400">
            A UK-registered special-purpose vehicle for life sciences and
            healthcare infrastructure development.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-3">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-left text-sm text-slate-400 transition-colors hover:text-gold"
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-14 gold-rule" />
      <div className="mt-6 flex flex-col justify-between gap-3 text-xs text-slate-500 sm:flex-row">
        <span>
          &copy; {new Date().getFullYear()} London Biotech International Limited.
          All rights reserved.
        </span>
        <span>Registered in the United Kingdom</span>
      </div>
    </div>
  </footer>
);
